
import React      from 'react';
import CSSModules from 'react-css-modules';

import FontIcon from '../FontIcon';
import PageLink from '../PageLink';

import style from './style.scss';

import classNames from 'classnames/bind';

class AdminSideBar extends React.Component {

    _getIconClass() {

        var cx = classNames.bind(style);

        return cx({
            'icon': true
        });
    }

    _getNavItemClass(target) {

        var cx = classNames.bind(style);

        return cx({
            'item': true,
            'item--active': window.location.pathname === target
        });
    }

    render() {

        return (
            <article styleName="side-bar">

                <img src="/assets/images/photos/profile_image.png" className={style['profile_image']}/>

                <ul>

                    <li className={ this._getNavItemClass('/dashboard/modules') }>

                        <PageLink styleName="link" to="/dashboard/modules">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="th-large"
                                      textPosition="right" />

                            <span styleName="title">Category</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/timetables') }>

                        <PageLink styleName="link" to="/dashboard/timetables">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="clock-o"
                                      textPosition="right" />

                            <span styleName="title">Timetables</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/presenters') }>

                        <PageLink styleName="link" to="/dashboard/presenters">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="users"
                                      textPosition="right" />

                            <span styleName="title">Presenters</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/resources') }>

                        <PageLink styleName="link" to="/dashboard/resources">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="files-o"
                                      textPosition="right" />

                            <span styleName="title">Resources</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/courses') }>

                        <PageLink styleName="link" to="/dashboard/courses">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="graduation-cap"
                                      textPosition="right" />

                            <span styleName="title">Courses</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/venues') }>

                        <PageLink styleName="link" to="/dashboard/venues">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="map-marker"
                                      textPosition="right" />

                            <span styleName="title">Venues</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/promotions') }>

                        <PageLink styleName="link" to="/dashboard/promotions">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="tags"
                                      textPosition="right" />

                            <span styleName="title">Promotions</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/events') }>

                        <PageLink styleName="link" to="/dashboard/events">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="calendar-o"
                                      textPosition="right" />

                            <span styleName="title">Events</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/transactions') }>

                        <PageLink styleName="link" to="/dashboard/transactions">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="shopping-cart"
                                      textPosition="right" />

                            <span styleName="title">Transactions</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/stats') }>

                        <PageLink styleName="link" to="/dashboard/stats">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="pie-chart"
                                      textPosition="right" />

                            <span styleName="title">Stats</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/marketing') }>

                        <PageLink styleName="link" to="/dashboard/marketing">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="bullhorn"
                                      textPosition="right" />

                            <span styleName="title">Marketing</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/elearning') }>

                        <PageLink styleName="link" to="/dashboard/elearning">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="graduation-cap"
                                      textPosition="right" />

                            <span styleName="title">ELearning</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/marketing-page-ad') }>

                        <PageLink styleName="link" to="/dashboard/marketing-page-ad">
                            <FontIcon className={ this._getIconClass() }
                                      iconName="buysellads"
                                      textPosition="right" />

                            <span styleName="title">Banner</span>
                        </PageLink>

                    </li>

                    <li className={ this._getNavItemClass('/dashboard/logout') }>

                        <div styleName="link" onClick={this.props.logout.bind(this)}>
                            <FontIcon className={ this._getIconClass() }
                                      iconName="power-off"
                                      textPosition="right" />

                            <span styleName="title">Logout</span>
                        </div>

                    </li>

                </ul>

            </article>
        );
    }
}

export default CSSModules(AdminSideBar, style);


// WEBPACK FOOTER //
// ./components/AdminSideBar/index.js